/* eslint-disable max-len */
import { SvgProps } from './types'

export const BuildingSearchIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg 
      width="30" 
      height="27" 
      viewBox="0 0 30 27" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_297_20116)">
        <path d="M18.5605 18.1258V23.1974" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.42969 23.1974V13.8791V4.61301V2.12366H14.0582" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M25.9004 10.9424L27.9373 11.4914V18.6835" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.89361 13.8791H1.35742V23.1974" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1.35742 23.1974H22.8508" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.0615 23.1974V19.4242H14.9313V23.1974" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.6977 7.13432H8.24707V4.14536H11.9215" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.6977 12.1972H8.24707V9.20828H10.0843" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.5774 17.2631H8.24707V14.2741H11.9215" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.89293 16.929H1.47656" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1.47656 19.8076H3.89293" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28.5422 25.5764C27.8804 26.0325 26.9817 25.8524 26.5367 25.1785L22.0605 18.4279L24.4569 16.7809L28.9331 23.5315C29.381 24.2054 29.2041 25.1204 28.5422 25.5735V25.5764Z" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.4994 18.1258L20.7734 15.5203" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23.9889 17.1033L22.3086 14.5646" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.7858 14.123C25.3393 11.523 25.3393 7.30762 22.7858 4.70766C20.2323 2.10769 16.0922 2.10769 13.5386 4.70766C10.9851 7.30762 10.9851 11.523 13.5386 14.123C16.0922 16.7229 20.2323 16.7229 22.7858 14.123Z" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_297_20116">
          <rect width="30" height="26.7491" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
